import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import GridBlock from 'components/GridBlock';
import DoubleButton from '../components/DoubleButton';
import Tr from 'translations/Translations';
import TextInput from 'components/TextInput';
import * as Yup from 'yup';
import VS from 'constants/ValidationShema';
import useId from 'hooks/useId';
import {connect} from 'react-redux'
import InputLimits from "constants/InputLimits";
import Loading from "../../Loading";
import TypographyWithIcon from "../../TypographyWithIcon";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";


const style = theme => ({
	root: {
		'&>*': {
			width: '100%'
		}
	},
	actions:{
		marginTop: theme.spacing(),
	}
})
const limits = InputLimits.procedure.contractor;
function PopupForm({
	classes,
	onSubmit,
	onClose,
	formSubmit,
	userList,
	error,
	working
}) {
	const formId = useId();

	const handleSubmit = () => {
		formSubmit[formId]()
	}

	return (
		<Form
			initialValues={{
				firstName: '',
				lastName: '',
				email: '',
			}}
			validationSchema={
				Yup.lazy((value) => {
					const validateObj = {
						firstName: VS.string(),
						lastName: VS.string()
					}
					let email
					const found = Boolean(userList.find(element => element.email === value.email))
					if (found) email = VS.immediatelyError(Tr("email_exist"))
					else email = VS.email(limits.EMAIL)

					return Yup.object().shape({
						...validateObj,
						email
					})
				})}
			onSubmit={onSubmit}
			id={formId}
		>
			{(formikProps) => (
				<GridBlock direction='column' className={classes.root}>
					{working && <Loading/>}
					{!!error && <TypographyWithIcon Icon={ErrorOutlineIcon} color='error'>{error}</TypographyWithIcon>}

					<TextInput
						id='firstName'
						formikProps={formikProps}
						label={Tr('firstName')}
						required
						disabled={working}
					/>
					<TextInput
						id='lastName'
						formikProps={formikProps}
						label={Tr('lastName')}
						required
						disabled={working}
					/>
					<TextInput
						id='email'
						formikProps={formikProps}
						label={Tr('email')}
						disabled={working}
					/>

					<div className={classes.actions}>
						<DoubleButton
							justify='flex-end'
							labelFirst={Tr('cancel')}
							labelSecond={Tr('add')}
							onClickFirst={onClose}
							onClickSecond={handleSubmit}
							disabledFirst={working}
							disabledSecond={working}
						/>
					</div>
				</GridBlock>
			)}
		</Form>
	)
}

PopupForm.propTypes = {
	classes: PropTypes.any,
}

export default connect((state) => ({
	formSubmit: state.form
}), {

	})(withStyles(style)(PopupForm));